const hasMatchedCondition = (conditions, answers) => {
  return conditions.find((condition) => {
    const answer = answers[condition.mainSurveyElementId];
    const expectedAnswer = condition.surveyElementQuestionOptionsChoiceId || condition.rating;
    const answerValue = answer ? answer.value : null;
    const isAnswerArray = Array.isArray(answerValue);
    return isAnswerArray ? answerValue.includes(expectedAnswer) : answerValue === expectedAnswer;
  });
};

const hasMoreVisibleQuestion = (currentIndex, questions, answers) => {
  const nextDefaultVisibleQuestion = questions.find((q, index) => {
    if (index <= currentIndex) return false;
    if (!q.displayConditions || q.displayConditions.length <= 0) return true;
    return hasMatchedCondition(q.displayConditions, answers);
  });
  return !!nextDefaultVisibleQuestion;
};

export { hasMatchedCondition, hasMoreVisibleQuestion };
